const translator = {
  esp: `
    Teksto de V. Matveeva <br/>
    Traduko de T. Auderskaja
  `
}
export default translator;